// list of query params that cannot be written to the URL
export const disallowedQueryParams: [string] = ['defaultFilterSet'];
